import React, { CSSProperties, ReactNode } from "react"
import styles from "./Table.module.css"
import util from "../../Utilities.module.css"

const Table = ({ children, className, style }: { children: ReactNode; className?: string; style?: CSSProperties }) => (
  <table className={`${styles.table} ${className}`} style={style}>
    {children}
  </table>
)

const TableRow = ({ children, style }: { children: ReactNode; style?: CSSProperties }) => (
  <tr className={styles.tableRow} style={style}>
    {children}
  </tr>
)

const TableHeader = ({ children, style }: { children: ReactNode; style?: CSSProperties }) => (
  <thead className={styles.tableHeader} style={style}>
    {children}
  </thead>
)

const TableBody = ({ children, style }: { children: ReactNode; style?: CSSProperties }) => (
  <tbody className={styles.tableBody} style={style}>
    {children}
  </tbody>
)

const TableHeaderCell = ({
  children,
  className,
  style,
  align = "left",
  hideOnMobile,
}: {
  children: ReactNode
  className?: string
  style?: CSSProperties
  align?: "left" | "right" | "center"
  hideOnMobile?: boolean
}) => {
  let computedClasses = className ?? ""
  // Alignment
  computedClasses += align === "right" ? ` ${util.alignRight}` : ` ${util.alignLeft}`

  // Hide on mobile
  computedClasses += hideOnMobile ? ` ${util.hide}` : ""

  return (
    <th className={computedClasses} style={style}>
      {children}
    </th>
  )
}

const TableCell = ({
  children,
  className,
  style,
  align = "left",
  numberType,
  hideOnMobile,
  shortenOnMobile = false,
}: {
  children: ReactNode
  className?: string
  style?: CSSProperties
  align?: "left" | "right" | "center"
  numberType?: "positive" | "negative"
  hideOnMobile?: boolean
  shortenOnMobile?: boolean
}) => {
  let computedClasses = className ?? ""
  // Alignment
  if (align === "right") {
    computedClasses += ` ${util.alignRight}`
  } else {
    computedClasses += ` ${util.alignLeft}`
  }

  // Text color
  if (numberType) {
    computedClasses += ` ${util[numberType]}`
  }

  // Hide on mobile
  if (hideOnMobile) {
    computedClasses += ` ${util.hide}`
  }

  // Ellipsis for long text
  if (shortenOnMobile) {
    computedClasses += ` ${util.ellipsis}`
  }

  return (
    <td className={computedClasses} style={style}>
      {children}
    </td>
  )
}

export { Table, TableRow, TableHeader, TableBody, TableHeaderCell, TableCell }
